import { ReactElement } from 'react';
import { joinClassNames } from '../../utils';
import styles from './NotificationCounter.module.scss';

type NotificationCounterProps = {
  children: ReactElement | ReactElement[];
  count: number;
  className?: string;
};

export const NotificationCounter = ({ className, children, count }: NotificationCounterProps) => (
  <span className={styles.notificationCounter}>
    <span
      className={joinClassNames(styles.notificationIndicator, className)}
      data-testid="notificationCounter"
    >
      {count}
    </span>
    {children}
  </span>
);
NotificationCounter.displayName = 'NotificationCounter';
